export default __webpack_public_path__ + "static/media/amazon.b99a7cc4.svg";